import enUS from './en-US';
import ruRU from './ru-RU';
export default {
    'en-US': enUS,
    'ru-RU': ruRU
};
